import { IModuleMetaData } from "./company-module";

export class ExtraDossiersMetaData {
	private metadata:IModuleMetaData;

	private constructor(metadata:IModuleMetaData){
		this.metadata = metadata;
	}

	public static create(metadata:IModuleMetaData):ExtraDossiersMetaData{
		return new ExtraDossiersMetaData(metadata || {});
	}

	public getExtraDossiers():number{
		return parseInt(this.metadata["extra-dossiers"] || "0") || 0;
	}

	public setExtraDossiers(count:number):void {
		this.metadata["extra-dossiers"] = `${count}`;
	}

	public getMetaData(){
		return {...this.metadata};
	}
}